<template>
  <div class="home">
    <div class="content">
      <div class="home-banner">
        <!-- <el-carousel trigger="click" :height="bannerHeight + 'px'">
        <el-carousel-item
          class="m-flex"
          v-for="item in slider"
          :key="item.name"
        >
          <div class="img-row m-flex m-row-center">
            <img :src="item.img" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel> -->
        <swiper
          :list="slider||[]"
          :height="871"
        ></swiper>
      </div>
      <div class="unit">
        <div class="title-home">
          <p class="fs30">
            <img src="@/assets/img/home_title_icon.png" />竞赛单元<img src="@/assets/img/home_title_icon.png" />
          </p>
          <p class="p4">COMPETITION UNITS</p>
        </div>
        <div class="competition m-flex m-col-top m-flex-wrap m-son-shrink">
          <div
            class="img-row"
            v-for="item in competition"
            :key="item.id"
            @click="toRegulation(item)"
          >
            <!-- <img src="@/assets/img/danyuan@2x.png" alt="" /> -->
            <img
              :src="item.cover"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="consultant">
        <div class="title-home">
          <p class="fs30">
            <img src="@/assets/img/home_title_icon.png" />专家顾问团<img src="@/assets/img/home_title_icon.png" />
          </p>
          <p class="p4">EXPERT ADVISORY</p>
        </div>
        <!-- 专家顾问开始 -->
        <div class="scroll-wrap">
          <div
            class="scroll-left"
            @click="scrollTap(0)"
          ></div>
          <div
            class="scroll-right"
            @click="scrollTap(1)"
          ></div>
          <div
            class="scroll-wrapper"
            ref="scroll"
          >
            <div class="scroll-content">
              <div
                class="scroll-item img-row"
                v-for="(item, index) in consultant"
                :key="index"
                @click="toConsultant"
              >
                <img
                  :src="item.cover"
                  alt=""
                />
                <p class="text-center">{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 专家顾问结束 -->
      </div>

      <div class="contact-wrap">
        <div class="title-home">
          <p class="fs30">
            <img src="@/assets/img/home_title_icon.png" />联系我们<img src="@/assets/img/home_title_icon.png" />
          </p>
          <p class="p4">CONTACT US</p>
        </div>
        <div class="contact m-flex">
          <div
            class="m-flex-3 chartone"
            ref="chartone"
          ></div>
          <div class="m-flex-2 contact-info">
            <div
              v-for="item in chinaActive.list"
              :key="item.id"
            >
              <p
                class="h3"
                v-if="item.name"
              >{{ item.name }}</p>
              <p class="h3">
                <img
                  src="@/assets/img/zhuban_icon.png"
                  alt=""
                />主办单位
              </p>
              <p v-if="item.sponsor">{{ item.sponsor }}</p>
              <p class="h3">
                <img
                  src="@/assets/img/mishu_icon.png"
                  alt=""
                />秘书处
              </p>
              <p v-if="item.contacts">联系人：{{item.contacts}}</p>
              <p v-if="item.consulting_telephone">咨询电话：{{ item.consulting_telephone }}</p>
              <p v-if="item.complaints_hotline">监督电话：{{item.complaints_hotline}}</p>
              <p v-if="item.email">电子邮箱：{{item.email}}</p>
              <p v-if="item.address">联系地址：{{ item.address }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/utils/factory.js";
import * as echarts from "echarts";
import swiper from "@/components/Swiper";
import BScroll from "@better-scroll/core";
import { Stock, chinaMap, para } from "@/store/mixin.js";

export default {
  mixins: [Stock, chinaMap, para],
  components: {
    swiper,
  },
  computed: {
    chinaActive: {
      get() {
        if (this.address == "全国") return { list: this.address_df };
        return this.getChinaData.find((item, index) => {
          return item.name == this.address;
        });
      },
      set(data) {
        return data;
      },
    },
  },
  data() {
    return {
      address: "全国", //当前地名
      address_df: {}, //地图默认地址
      slider: [], //轮播图
      competition: [], //竞赛单元
      consultant: [], //专家顾问
      bannerHeight: 350,
      bs_scroll: null, //专家顾问滚动区域
    };
  },
  watch: {
    consultant() {
      this.bs_scroll.refresh();
    },
  },
  created() {
    this.getSlider();
    this.getCompetition();
    this.getConsultant();
    this.getContact();
  },
  mounted() {
    const that = this;
    this.setChartone();
    this.bsCrollInit();
  },
  methods: {
    // 专家顾问模块滚动
    bsCrollInit() {
      let that = this;
      this.bs_scroll = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3, // listening scroll event
      });
      setTimeout(() => {
        that.bs_scroll.refresh();
      }, 500);
    },
    // 顾问模块点击滚动
    scrollTap(num) {
      this.bs_scroll.refresh();
      let extraTransform = {
          // 起点的属性
          start: {
            scale: 0,
          },
          // 终点的属性
          end: {
            scale: 1.1,
          },
        },
        width = this.$refs.scroll.offsetWidth,
        { x, maxScrollX } = this.bs_scroll;
      //console.log(width, x, maxScrollX);
      if (num) {
        if (width + maxScrollX <width)return this.bs_scroll.scrollTo(maxScrollX, 0,300,undefined,extraTransform);
        x -= width;
        // 右
        this.bs_scroll.scrollTo(x, 0, 300, undefined, extraTransform);
      } else {
        if (x < width)return this.bs_scroll.scrollTo(0, 0, 300, undefined, extraTransform);
        x += width;
        // 左
        this.bs_scroll.scrollTo(x, 0, 300, undefined, extraTransform);
      }
    },
    // 轮播图
    async getSlider() {
      let res = await this.$api.getSlider();
      //console.log("轮播图", res);
      if (res.code == 1) {
        this.slider = res.data;
      }
    },
    // 竞赛单元详情
    async getCompetition() {
      let res = await this.$api.getCompetition();
      //console.log("竞赛单元", res);
      if (res.code == 1) {
        this.competition = res.data;
      }
    },
    // 专家顾问
    async getConsultant() {
      const that = this;
      let res = await this.$api.getConsultant();
      //console.log("专家顾问", res);
      if (res.code == 1) {
        this.consultant = res.data;
        if (!that.bs_scroll) return;
        setTimeout(() => {
          that.bs_scroll.refresh();
        }, 500);
      }
    },
    toConsultant() {
      this.$router.push("/consultant");
    },
    // 联系我们
    async getContact() {
      let res = await this.$api.getContact(),
        mydata = this.getChinaData;
      if (res.code == 1) {
        let { data } = res;
        data = this.$var.sortArr(data, "provinces");
        mydata.forEach((map_item, map_index) => {
          data.forEach((data_value) => {
            for (let i = 0; i < data_value.length; i++) {
              if (data_value[i].provinces == "全国") {
                this.address_df = data_value;
                break;
              }
              if (data_value[i].provinces == map_item.name) {
                mydata[map_index].value = data_value.length;
                mydata[map_index].list = data_value;
                break;
              }
            }
          });
        });
        this.setChartone();
      }
    },
    // 点击进入竞赛
    toRegulation(item) {
      this.$cache.setCache('regulation',item)
      this.$router.push("/regulation");
    },
    // 中国地图
    setChartone() {
      const that = this;
      //初始化echarts实例
      var myChart = echarts.init(this.$refs.chartone);
      let imgIcon1 = "@/assets/img/org_dot.png",
        imgIcon2 = "@/assets/img/red_dot.png";
      var optionMap = {
        backgroundColor: "transparent",
        title: {
          text: "",
          subtext: "",
          y: "5%",
          x: "center",
        },
        tooltip: {
          show: false,
          trigger: "item",
        },
        //左侧小导航图标
        visualMap: {
          show: false,
          x: "left",
          y: "center",
          splitList: [{ start: 0, end: 100 }],
          color: ["#a0d2f2"],
        },
        showLegendSymbol: true,
        geo: [
          {
            name: "中国地图",
            map: "china",
            roam: false,
            zoom: 1.2,
            select: {
              disabled: true,
            },
            label: {
              normal: {
                show: true, //省份名称
                color: "#82240A",
              },
              emphasis: {
                color: "#87AA53",
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#FEAC00",
                borderColor: "#F79E27",
                borderWidth: 1,
              },
              emphasis: {
                color: "#FEAC00",
              },
            },
            data: this.getChinaData, //数据
          },
        ],
        //配置属性
        series: [
          {
            name: "",
            type: "effectScatter",
            coordinateSystem: "geo",
            type: "custom",
            renderItem: function (params, api) {
              const data = that.getChinaData; // 处理数据
              let index = params.dataIndex;
              let deviceType = data[index].deviceType;
              let array = [imgIcon1, imgIcon2]; // 此处为引进的两张图片
              return addImage(array[deviceType], params, api, data);
            },
            data: this.getChinaData,
            symbolSize: function (val) {
              return val[2] / 10;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true,
              },
            },
            zlevel: 1,
          },
        ],
      };
      function addImage(url, params, api, realData) {
        if (!realData[params.dataIndex].value) return;
        return {
          type: "image",
          style: {
            text: realData[params.dataIndex].value,
            textFill: "#ffffff",
            image: "http://dist.ycywlkj.com/icon/org_dot.png",
            x:
              api.coord([
                realData[params.dataIndex].center[0],
                realData[params.dataIndex].center[1],
              ])[0] - 10,
            y:
              api.coord([
                realData[params.dataIndex].center[0],
                realData[params.dataIndex].center[1],
              ])[1] - 30,
            width: 15,
            height: 22,
          },
        };
      }
      //使用制定的配置项和数据显示图表
      myChart.setOption(optionMap);
      //点击地图事件
      myChart.on("click", (params) => {
        that.getChinaData.forEach((item) => {
          if (params.name == item.name) {
            if (item.value == 0) return (this.address = "全国");
            this.address = item.name;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 1px;
  & > div {
    margin-bottom: 50px;
  }
}
.home {
  background: url(@/assets/img/guoqi.png) no-repeat bottom right/1800px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}
.home-banner {
  position: relative;
  & ::v-deep {
    .el-carousel--horizontal {
      overflow: hidden;
    }
    .el-carousel__item {
      margin: 0;
    }
  }
  .img-col {
    height: 100%;
  }
}
.unit {
  .competition {
    width: 100%;
    .img-row {
      width: 32%;
      margin-top: 2%;
      margin-right: 2%;
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
      &:nth-child(-n + 3) {
        margin-top: 0;
      }
    }
  }
}
.consultant {
  // 专家顾问左右滑动
  .scroll-wrap {
    position: relative;
    .scroll-left,
    .scroll-right {
      position: absolute;
      z-index: 9;
      top: 50%;
      width: 4em;
      height: 4em;
      background: no-repeat center / 100% 100%;
      transform: translateY(-50%) !important;
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
    }
    .scroll-left {
      left: 0;
      background-image: url(@/assets/img/banner2_left@2x.png);
    }
    .scroll-right {
      right: 0;
      background-image: url(@/assets/img/banner2_right@2x.png);
    }
  }
  .scroll-wrapper {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    .scroll-content {
      display: inline-block;
    }
  }
  .scroll-item {
    position: relative;
    display: inline-block;
    width: 297px;
    height: 352px;
    margin-right: 64px;
    &:last-child {
      margin-right: 0;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 1.2em;
      background: #e03201;
      color: #fff;
    }
  }
}
/* .consultant {
    li {
      width: 22%;
      margin-right: 4%;
      &:last-child {
        margin-right: 0;
      }
      .img-row {
        background: no-repeat top/100%;
        img{opacity: 0;}
      }
      p {
        padding: 0.5em;
        background: #fff;
      }
    }
  } */
.contact-wrap {
  padding-bottom: 60px;
}
.contact {
  .chartone {
    margin-right: 20px;
    height: 500px;
  }
  .m-flex-2 {
    line-height: 3;
  }
  .contact-info {
    height: 400px;
    overflow-y: scroll;
    color: #fff;
    img {
      width: 1.2em;
      margin-right: 0.5em;
    }
    & > div {
      margin-bottom: 40px;
      p {
        text-indent: 2em;
        &.h3 {
          text-indent: 0;
        }
      }
    }
  }
}
</style>
  